export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "FileUploadWorker-fbdab98d6bf8e941db21.worker.js");
}
